module.exports = __webpack_public_path__ + "img/img3.10e80a51.jpg";